export var EIntegrityCheckError;
(function (EIntegrityCheckError) {
    EIntegrityCheckError["IO_ERROR"] = "io-error";
    EIntegrityCheckError["HASH_MISSMATCH"] = "hash-mismatch";
    EIntegrityCheckError["HASH_COMPUTING_ERROR"] = "hash-computing-error";
})(EIntegrityCheckError || (EIntegrityCheckError = {}));
export var IAudienceSelection;
(function (IAudienceSelection) {
    IAudienceSelection["ALL_USERS"] = "ALL_USERS";
    IAudienceSelection["NOT_VOTED"] = "NOT_VOTED";
    IAudienceSelection["VOTED"] = "VOTED";
    IAudienceSelection["SELECTED"] = "SELECTED";
})(IAudienceSelection || (IAudienceSelection = {}));
export var ETemplateType;
(function (ETemplateType) {
    ETemplateType["CREDENTIALS"] = "CREDENTIALS";
    ETemplateType["INITIALIZATION_REPORT"] = "INITIALIZATION_REPORT";
    ETemplateType["ELECTORAL_RESULTS"] = "ELECTORAL_RESULTS";
    ETemplateType["BALLOT_IMAGES"] = "BALLOT_IMAGES";
    ETemplateType["BALLOT_RECEIPT"] = "BALLOT_RECEIPT";
    ETemplateType["ACTIVITY_LOGS"] = "ACTIVITY_LOGS";
    ETemplateType["MANUAL_VERIFICATION"] = "MANUAL_VERIFICATION";
    ETemplateType["PARTICIPATION_REPORT"] = "PARTICIPATION_REPORT";
})(ETemplateType || (ETemplateType = {}));
export var ITemplateMethod;
(function (ITemplateMethod) {
    ITemplateMethod["EMAIL"] = "EMAIL";
    ITemplateMethod["SMS"] = "SMS";
    ITemplateMethod["DOCUMENT"] = "DOCUMENT";
    ITemplateMethod["WHATSAPP"] = "WHATSAPP";
    ITemplateMethod["VIBER"] = "VIBER";
    ITemplateMethod["MESSENGER"] = "MESSENGER";
})(ITemplateMethod || (ITemplateMethod = {}));
/** Methods that send a message to the voter, in the order they are offered. */
export var MESSAGE_TEMPLATE_METHODS = [
    ITemplateMethod.WHATSAPP,
    ITemplateMethod.VIBER,
    ITemplateMethod.MESSENGER,
    ITemplateMethod.SMS,
    ITemplateMethod.EMAIL,
];
